import { render, staticRenderFns } from "./risk-first.vue?vue&type=template&id=1ee90e84&scoped=true&"
import script from "./risk-first.vue?vue&type=script&lang=js&"
export * from "./risk-first.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee90e84",
  null
  
)

export default component.exports